<template>
  <div>
    <div class="w-full mb-4">
      <h2 class="text-white p-4 text-2xl font-semibold" :class="`bg-${color}-700`" v-text="title"></h2>
      <div class="flex flex-wrap p-2 text-blue-500" :class="`bg-${color}-300`">
        <slot></slot>
        <div class="p-2 pt-10 w-full md:w-1/2">
          <v-button
            id="search"
            :color="color"
            :class="`bg-${color}-700 w-full text-white border-${color}-700 pt-3`"
            @click="handleClick"
            :title="__('Suchen')"
          >
            {{ __('Suchen') }}
          </v-button>
        </div>
        <div class="w-full p-2">
          <p v-if="searched" v-html="resultTotal"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: '',
    color: '',
    resultTotal: '',
    searched: false,
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>
